/* eslint-disable react-hooks/rules-of-hooks */
import { Menu } from 'antd';
import React from 'react';
import { Trans } from 'react-i18next';

interface IUrlTitle {
  url: string;
  title: string;
}
const urls: Array<IUrlTitle> = [
  {
    title: 'options.tutorial',
    url: 'https://www.youtube.com/watch?v=_wm6pa6gATs',
  },
  { title: 'options.emailUs', url: 'mailto:design@summerwood.com' },
  {
    title: 'options.liveChat',
    url: 'https://www.summerwood.com/support?chat_opened=1',
  },
  {
    title: 'options.glitch',
    url: 'mailto:support@summerwood.com?subject=Report a Design Centre Glitch',
  },
];

export const helpMenu = (
  <Menu>
    {urls.map((u) => (
      <Menu.Item key={u.title}>
        <a
          target="_blank"
          rel="noopener noreferrer"
          href={u.url}
          style={{ color: 'black' }} // have to use black because there is an issue with Theme access
        >
          <Trans>{u.title}</Trans>
        </a>
      </Menu.Item>
    ))}
  </Menu>
);
